import { render } from "./baseFooter.vue?vue&type=template&id=163d5f72&scoped=true"
import script from "./baseFooter.vue?vue&type=script&lang=js"
export * from "./baseFooter.vue?vue&type=script&lang=js"

import "./baseFooter.vue?vue&type=style&index=0&id=163d5f72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-163d5f72"

export default script